import React from 'react';
import { SHIPPER_COMMS } from '@/components/Account/ShipperAccount/comms';
import ProfileSection from '../../components/ProfileSection';
import ReadOnlyFlagList from '../../components/ReadOnlyFlagList';

/**
 * The Communication tab of a shipper's profile: the communication settings the shipper chose on
 * their own Profile. Read only; the values are the shipper's `users.circles`.
 * @param {{ partnership: Object }} props
 */
const CommunicationsPage = ({ partnership }) => (
    <ProfileSection title="Communications">
        <ReadOnlyFlagList flags={SHIPPER_COMMS} values={partnership.shipper?.user?.circles || {}} />
    </ProfileSection>
);

export default CommunicationsPage;
